import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TAG_COLORS } from 'components/config/promotions';

import styles from 'components/pages/Promotions/Tags/Tags.module.scss';

const Tags = ({ tags, className }) => (
  <div className={classNames(styles.wrapper, className)}>
    {tags?.map(({ key, value }) => {
      const { color, backgroundColor } = TAG_COLORS[key] ?? {};

      return (
        <div
          key={key}
          className={styles.tag}
          style={{
            color,
            backgroundColor,
          }}
        >
          {value}
        </div>
      );
    })}
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export default memo(Tags);
